export class Device {
  "dev_name": String;
  "serial_no": Number;
  "company_name": String;
  "make_id": String;
  "max_param_count": Number;
  "inverter_capacity": String;
  "registered_by": String;
  "device_type":String;
}



export class WMS {
  "user_name": String;
  "name": String;
  "email": any;
  "password": any;
  "mobile_no": Number;
  // "date_of_birth": any;
  "address": String;
  "instd_capacity": String;
  "num_inverter": Number;
  "elec_rate": Number;
  "start_dt": any;
  "end_dt": any;
  "solar_panel": String;
  // "solar_inv": String;
  "num_solar_panel": Number;
  "area_solar_panel": Number;
  "eff_solar_panel": Number;
  "t_coeff_v": Number;
  "t_coeff_p": Number;
  //"device_id": any;
}


export class NormalUser {
  "user_name": String;
  "name": String;
  "email": any;
  "password": any;
  "mobile_no": Number;
  // "date_of_birth": any;
  "address": String;
  "instd_capacity": String;
  "num_inverter": Number;
  "elec_rate": Number;
  "start_dt": any;
  "end_dt": any;
  "solar_panel": String;
  // "solar_inv": String;
  "num_solar_panel": Number;
  // "area_solar_panel": Number;
  // "eff_solar_panel": Number;
  // "t_coeff_v": Number;
  // "t_coeff_p": Number;
 // "device_id": any;
}

export class CheckUser{
  "user_name": String;
}
export class EpcAdd {
  "login_id": String;
  "name": String;
  "email": any;
  "password": any;
  "mobile_no":  String;
  // "date_of_birth": any;
  "address": String;
  "company_name": String;
  "website": any;
  "company_email": any;
  "contact_name": String;
  "logo": any;
}

export class  RegisterDevice{
  "device_id":any;
  "sub_device_info":[ {'sub_device_number': Number,'sub_device_name': String} ];
}
export class alarmError {
  "user_id":any;
  "start_date":any;
  "end_date":any;
}